import { e as error } from "../../../../chunks/index2.js";
import * as path from "node:path";
import { c as read_implementation, b as base, m as manifest } from "../../../../chunks/server.js";
import { a as b64_decode } from "../../../../chunks/utils.js";
function read(asset) {
  ;
  if (!read_implementation) {
    throw new Error(
      "No `read` implementation was provided. Please ensure that your adapter is up to date and supports this feature"
    );
  }
  const match = /^data:([^;,]+)?(;base64)?,/.exec(asset);
  if (match) {
    const type = match[1] ?? "application/octet-stream";
    const data = asset.slice(match[0].length);
    if (match[2] !== void 0) {
      const decoded2 = b64_decode(data);
      return new Response(decoded2, {
        headers: {
          "Content-Length": decoded2.byteLength.toString(),
          "Content-Type": type
        }
      });
    }
    const decoded = decodeURIComponent(data);
    return new Response(decoded, {
      headers: {
        "Content-Length": decoded.length.toString(),
        "Content-Type": type
      }
    });
  }
  const file = decodeURIComponent(
    asset.slice(base.length + 1)
  );
  if (file in manifest._.server_assets) {
    const length = manifest._.server_assets[file];
    const type = manifest.mimeTypes[file.slice(file.lastIndexOf("."))];
    return new Response(read_implementation(file), {
      headers: {
        "Content-Length": "" + length,
        "Content-Type": type
      }
    });
  }
  throw new Error(`Asset does not exist: ${file}`);
}
const modules = /* @__PURE__ */ Object.assign({ "/src/lib/client/assets/alex.png": () => import("../../../../chunks/alex.js"), "/src/lib/client/assets/forms-pinkish-blur.png": () => import("../../../../chunks/forms-pinkish-blur.js"), "/src/lib/client/assets/glimmr-product-diagram.png": () => import("../../../../chunks/glimmr-product-diagram.js"), "/src/lib/client/assets/happy-customer.png": () => import("../../../../chunks/happy-customer.js"), "/src/lib/client/assets/icon.ico": () => import("../../../../chunks/icon.js"), "/src/lib/client/assets/icon.png": () => import("../../../../chunks/icon2.js"), "/src/lib/client/assets/icon.svg": () => import("../../../../chunks/icon3.js"), "/src/lib/client/assets/jordan.png": () => import("../../../../chunks/jordan.js"), "/src/lib/client/assets/mia.png": () => import("../../../../chunks/mia.js"), "/src/lib/client/assets/riley.png": () => import("../../../../chunks/riley.js") });
const GET = async ({ params }) => {
  const filename = params.filename;
  const modulePath = Object.keys(modules).find(
    (modulePath2) => path.basename(modulePath2) === filename
  );
  if (!modulePath) {
    return error(404, {
      message: "File not found"
    });
  }
  const module = await modules[modulePath]();
  console.log(import.meta.url);
  console.log();
  return read(
    path.join(
      import.meta.url.replace("file://", ""),
      "..",
      "..",
      "..",
      "..",
      "..",
      module?.default
    )
  );
};
export {
  GET
};
